import { useQueryWithUserId } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

/**
 * This key is used to track useTransferListQuery
 */
export const TRANSFER_PENDENCIES_QUERY_KEY = 'transfer-pendencies-query-key';

/**
 * This hook fetches the transfer pendencies list without pagination.
 */
export const useFetchTransferPendenciesQuery = () => {
  const { data, error, isError, isPending, refetch } = useQueryWithUserId({
    queryKey: [TRANSFER_PENDENCIES_QUERY_KEY],
    networkMode: 'always',
    retry: false,
    queryFn: () => INV_MGMT_SERVICE_API.getAllTransferPendencies(),
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
};
